module.exports = __webpack_public_path__ + "static/assets/af8aa08b4d6de84ae7cc3e54da3750fc.png";